module.exports = "<p>\n  cold-calls-files works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cold-calls-files/cold-calls-files.component.html
// module id = ./src/app/cold-calls-files/cold-calls-files.component.html
// module chunks = main